import { Box, Button, Dialog, Typography, useMediaQuery, useTheme } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import useOpenable from '../../hooks/useOpenable';
import ContactInformationSettings from '../settingsDialog/ContactInformationSettings';
import ContactInformationTemplate from './ContactInformationTemplate';
import EmailContactInformationDisplay from './EmailContactInformationDisplay';
import PhoneContactInformationDisplay, { PhoneType } from './PhoneContactInformationDisplay';

export default function ContactInformationCard(): React.JSX.Element {
  const { open, close, isOpen } = useOpenable();
  const { t } = useTranslation(['common', 'settings']);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ mx: 1.5 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="titleLarge">
          {t('settings:your_contact_information_short')}
        </Typography>
        <Button
          variant="tonal"
          startIcon={!isSmall && <EditOutlined />}
          onClick={open}
        >
          {isSmall ? <EditOutlined /> : t('common:modify')}
        </Button>
      </Box>
      <ContactInformationTemplate
        mobilePhoneNumberComponent={<PhoneContactInformationDisplay phoneType={PhoneType.MOBILE} />}
        landlineNumberComponent={<PhoneContactInformationDisplay phoneType={PhoneType.LANDLINE} />}
        emailComponent={<EmailContactInformationDisplay />}
      />
      <Dialog
        open={isOpen}
        onClose={(): void => { /* noop */ }}
        sx={{
          mx: {
            xs: 2,
            sm: 0,
          },
          '& .MuiPaper-root.MuiDialog-paper': {
            minWidth: {
              xs: '100%',
              sm: 640,
            },
          },
        }}
      >
        <ContactInformationSettings
          next={close}
          standAlone
          submitLabel={t('common:validate')}
          cancelLabel={t('common:cancel')}
        />
      </Dialog>
    </Box>
  );
}
